<template>
  <svg
    width="180"
    height="180"
    viewBox="0 0 180 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M171.955 117.874C153.809 158.848 105.91 176.447 68.3803 173.447C58.1332 172.627 37.5156 170.979 21.4173 156.272C-9.49843 128.029 -4.73711 68.9921 24.8581 34.2346C28.6693 29.7586 55.0502 -0.230422 96.16 0.170985C126.258 0.464905 147.384 16.8897 149.953 18.936C153.198 21.5209 160.355 27.6635 166.806 37.4084C181.962 60.3055 183.294 92.2698 171.955 117.874Z"
      fill="white"
      fill-opacity="0.4"
    />
    <g opacity="0.3">
      <path
        d="M61.0501 36.117C61.4284 36.021 61.8263 36.223 61.9646 36.5954C62.2671 37.4097 62.5385 38.2492 62.7714 39.0905C62.8847 39.4998 62.6432 39.923 62.2319 40.0357C62.2269 40.0369 62.2221 40.0382 62.2173 40.0394C61.8106 40.1426 61.3939 39.9032 61.2821 39.4988C61.0609 38.6995 60.803 37.9021 60.5157 37.1285C60.3677 36.7304 60.5721 36.2882 60.9725 36.1411C60.998 36.1315 61.0241 36.1236 61.0501 36.117ZM62.6646 42.617C62.6939 42.6096 62.7239 42.6038 62.7546 42.5997C63.1775 42.5439 63.566 42.8397 63.6221 43.2605C63.7372 44.1248 63.8165 45.0025 63.8574 45.8693C63.8774 46.2934 63.5497 46.6519 63.1221 46.6733C62.6959 46.6931 62.3343 46.3654 62.3143 45.9416C62.2754 45.1178 62.2001 44.284 62.0904 43.4626C62.0384 43.0724 62.2905 42.7119 62.6646 42.617ZM62.8004 49.3091C62.8837 49.2879 62.9721 49.2804 63.0627 49.2887C63.4874 49.3281 63.7999 49.7024 63.7605 50.1251C63.6798 50.9914 63.5601 51.8651 63.4047 52.7218C63.3287 53.1395 62.9269 53.4166 62.5074 53.3417C62.0877 53.2663 61.8086 52.8666 61.8844 52.4489C62.0319 51.6354 62.1455 50.806 62.2222 49.9831C62.2532 49.6505 62.4929 49.3871 62.8004 49.3091ZM61.4286 55.8647C61.5663 55.8297 61.7153 55.8322 61.8603 55.8797C62.2656 56.0124 62.4858 56.4469 62.3525 56.85C62.0787 57.677 61.7658 58.5021 61.4224 59.3025C61.2547 59.6923 60.8011 59.8737 60.4087 59.7075C60.0164 59.5408 59.8342 59.0892 60.0016 58.6988C60.3278 57.9388 60.6252 57.1551 60.885 56.3691C60.9708 56.1103 61.1814 55.9274 61.4286 55.8647ZM58.6221 61.9512C58.8153 61.9021 59.0271 61.9271 59.2113 62.0375C59.5769 62.2564 59.6948 62.7286 59.4747 63.0922C59.0245 63.8362 58.536 64.5718 58.0225 65.2777C57.7727 65.6218 57.2897 65.6991 56.9439 65.4501C56.5984 65.2012 56.5209 64.7208 56.7709 64.3768C57.259 63.7058 57.7234 63.0067 58.1512 62.2996C58.2604 62.1192 58.4321 61.9994 58.6221 61.9512ZM54.5325 67.268C54.7826 67.2046 55.059 67.2671 55.2589 67.458C55.5667 67.752 55.5767 68.2384 55.2815 68.5447C54.6761 69.1723 54.036 69.7821 53.3791 70.3565C53.0584 70.6367 52.5705 70.6053 52.2889 70.2864C52.0074 69.9678 52.0388 69.4821 52.3592 69.2018C52.9834 68.6559 53.5915 68.0768 54.1668 67.4804C54.2703 67.373 54.3976 67.3023 54.5325 67.268ZM27.5596 75.9998C27.6632 75.9735 27.7738 75.9684 27.8859 75.9883C28.7029 76.1336 29.5372 76.2454 30.3657 76.3202C30.7904 76.3586 31.1036 76.7324 31.0649 77.1549C31.0264 77.5777 30.6507 77.8893 30.2258 77.8508C29.3533 77.772 28.4745 77.6545 27.6142 77.5016C27.1942 77.4269 26.9147 77.0275 26.9897 76.6097C27.0447 76.3034 27.2751 76.072 27.5596 75.9998ZM49.3637 71.5481C49.6742 71.4694 50.0141 71.5894 50.1999 71.8707C50.4344 72.2255 50.3354 72.702 49.9791 72.9353C49.2486 73.4134 48.4882 73.8656 47.7191 74.2795C47.3431 74.4796 46.8752 74.3427 46.6721 73.9692C46.4692 73.596 46.6089 73.1295 46.9842 72.9274C47.7146 72.5345 48.4365 72.105 49.1303 71.6511C49.2041 71.6029 49.2829 71.5686 49.3637 71.5481ZM34.2748 76.427C34.3242 76.4145 34.3755 76.4064 34.4284 76.4038C35.2579 76.3635 36.0965 76.2867 36.9211 76.1763C37.344 76.1198 37.7329 76.415 37.7898 76.8355C37.8465 77.2561 37.5507 77.645 37.1273 77.6998C36.2596 77.8158 35.3771 77.8965 34.5044 77.9392C34.0782 77.96 33.7158 77.6331 33.6949 77.2092C33.6766 76.8381 33.9263 76.5154 34.2748 76.427ZM43.3636 74.5721C43.7414 74.4763 44.1388 74.6776 44.2775 75.0491C44.4262 75.447 44.2226 75.8894 43.8228 76.0376C43.0041 76.3404 42.1612 76.6122 41.3175 76.8448C41.3124 76.8465 41.3069 76.8479 41.3017 76.8492C40.8956 76.9522 40.4794 76.7135 40.3668 76.31C40.2527 75.9008 40.4934 75.4772 40.9046 75.3639C41.7059 75.1427 42.5065 74.8844 43.2843 74.5966C43.3107 74.5872 43.3372 74.5789 43.3636 74.5721Z"
        fill="#BDD0FB"
      />
      <path
        d="M22.3276 74.5737C22.475 74.5363 22.635 74.5415 22.7884 74.5987C23.1614 74.7376 23.5435 74.8708 23.9242 74.9955C24.3294 75.1278 24.5502 75.5623 24.417 75.9654C24.2841 76.3687 23.8474 76.5889 23.4421 76.4556C23.0416 76.3249 22.6398 76.1845 22.2472 76.0384C21.8477 75.8897 21.6448 75.4467 21.7943 75.0494C21.8864 74.8043 22.0909 74.6338 22.3276 74.5737Z"
        fill="#BDD0FB"
      />
    </g>
    <g opacity="0.3">
      <path
        d="M5.24424 58.4456C5.60551 58.3539 5.99026 58.5339 6.14315 58.8851C6.30125 59.2487 6.46974 59.6152 6.64396 59.9741C6.82942 60.3565 6.66837 60.816 6.28421 61.0004C5.89841 61.1857 5.43813 61.0245 5.25273 60.6425C5.06944 60.2646 4.89193 59.8786 4.72535 59.4958C4.55593 59.1063 4.73594 58.6539 5.1274 58.4851C5.16576 58.4686 5.20497 58.4556 5.24424 58.4456Z"
        fill="#BDD0FB"
      />
      <path
        d="M25.3804 17.5352C25.7248 17.4478 26.072 17.3659 26.4218 17.2895C26.8386 17.1986 27.2505 17.4609 27.3419 17.8755C27.4334 18.2901 27.1681 18.7019 26.7531 18.7911C25.9456 18.9675 25.1471 19.1759 24.3709 19.4138C23.9626 19.5381 23.5309 19.3112 23.4053 18.9056C23.2796 18.4997 23.5085 18.0695 23.9162 17.9447C24.3963 17.7975 24.889 17.6598 25.3804 17.5352ZM30.4556 16.6927C30.4974 16.6821 30.5409 16.6748 30.5855 16.6712C31.4445 16.6023 32.3161 16.5689 33.1758 16.572C33.6023 16.5735 33.9469 16.9188 33.9454 17.343C33.9438 17.7676 33.5963 18.1117 33.1701 18.1089C32.3536 18.106 31.5257 18.1379 30.7093 18.2031C30.2841 18.2372 29.9117 17.9218 29.8774 17.499C29.8468 17.1201 30.0976 16.7835 30.4556 16.6927ZM20.1237 19.4002C20.4766 19.3107 20.8546 19.4803 21.0139 19.8206C21.194 20.2056 21.0264 20.6626 20.6397 20.8419C19.8999 21.1845 19.1648 21.5634 18.4546 21.9685C18.0842 22.179 17.6124 22.052 17.4003 21.6839C17.1882 21.3154 17.3163 20.8458 17.6865 20.6347C18.4342 20.2083 19.2085 19.8093 19.9876 19.4483C20.0322 19.4277 20.0778 19.4118 20.1237 19.4002ZM37.0763 16.8901C37.1713 16.866 37.2725 16.8599 37.3755 16.8743C38.228 16.9949 39.0856 17.1531 39.9244 17.3445C40.3401 17.4395 40.5998 17.8517 40.5043 18.2654C40.4089 18.6794 39.9948 18.9377 39.5787 18.8425C38.7823 18.6608 37.968 18.5105 37.1583 18.3961C36.736 18.3366 36.4422 17.9473 36.5022 17.5272C36.5475 17.2096 36.782 16.9648 37.0763 16.8901ZM14.4704 22.8236C14.7598 22.7501 15.0786 22.8483 15.2729 23.0986C15.5337 23.4346 15.4714 23.9173 15.1337 24.1768C14.4881 24.6728 13.8548 25.2034 13.2511 25.7537C12.9366 26.0405 12.448 26.0194 12.1597 25.7063C11.8717 25.3933 11.893 24.9074 12.2075 24.6207C12.8429 24.0412 13.5096 23.4826 14.1895 22.9603C14.2754 22.8941 14.3712 22.8487 14.4704 22.8236ZM9.70879 27.3985C9.94018 27.3398 10.1956 27.3884 10.3935 27.5516C10.7218 27.8228 10.767 28.3073 10.4945 28.6339C9.97209 29.2604 9.46997 29.916 9.00226 30.5825C8.75857 30.9309 8.27717 31.0161 7.92683 30.7729C7.57702 30.5298 7.49149 30.0508 7.73558 29.7027C8.22776 29.0012 8.75607 28.3113 9.30602 27.6523C9.41411 27.5225 9.55616 27.4372 9.70879 27.3985ZM6.06289 32.8974C6.23889 32.8528 6.4312 32.8693 6.60567 32.9583C6.98529 33.1517 7.13549 33.6149 6.94095 33.9926C6.56758 34.7179 6.22086 35.4664 5.91059 36.218C5.74854 36.6104 5.29767 36.7983 4.90253 36.6367C4.50805 36.4753 4.31955 36.0265 4.48166 35.6337C4.80832 34.8429 5.17307 34.0548 5.56591 33.2919C5.67111 33.0876 5.85559 32.95 6.06289 32.8974ZM3.70921 39.0561C3.83118 39.0252 3.96231 39.0235 4.09277 39.057C4.50581 39.1632 4.75397 39.5824 4.6472 39.9933C4.44232 40.7817 4.26903 41.5876 4.13218 42.3888C4.06066 42.8072 3.66125 43.0889 3.24137 43.0179C2.8207 42.9468 2.53772 42.5498 2.60924 42.1314C2.75332 41.2875 2.93583 40.4387 3.15143 39.6088C3.22465 39.3274 3.44505 39.1231 3.70921 39.0561ZM2.77148 45.5813C2.84004 45.5639 2.91221 45.5558 2.98649 45.558C3.41282 45.571 3.74796 45.9256 3.73473 46.3497C3.70973 47.1616 3.71921 47.9852 3.76309 48.7981C3.78599 49.2221 3.45782 49.5839 3.0332 49.6067C2.6072 49.6296 2.24324 49.3043 2.22041 48.8804C2.17423 48.0246 2.16423 47.1574 2.19068 46.3028C2.20147 45.9524 2.44634 45.6637 2.77148 45.5813ZM3.29703 52.1475C3.31242 52.1436 3.32801 52.1403 3.34374 52.1372C3.7627 52.0575 4.16731 52.331 4.24725 52.7479C4.36021 53.3364 4.49279 53.9282 4.64128 54.5078C4.69503 54.7175 4.75121 54.9263 4.80918 55.1338C4.92352 55.5429 4.68305 55.9666 4.27206 56.0802C3.85823 56.2035 3.43525 55.9548 3.32091 55.5461C3.25979 55.3276 3.20097 55.1083 3.14439 54.8875C2.9882 54.2781 2.84879 53.6551 2.72997 53.0362C2.65286 52.635 2.90451 52.2471 3.29703 52.1475Z"
        fill="#BDD0FB"
      />
      <path
        d="M43.5076 18.5405C43.6565 18.5027 43.8178 18.5085 43.9721 18.5667C44.3631 18.7145 44.7583 18.8732 45.1468 19.0386C45.5391 19.2055 45.7211 19.6572 45.5532 20.0474C45.3853 20.4376 44.9318 20.619 44.5393 20.4518C44.1703 20.2948 43.7948 20.144 43.4237 20.0037C43.025 19.8532 42.8244 19.4093 42.9758 19.0125C43.0687 18.7693 43.2723 18.6002 43.5076 18.5405Z"
        fill="#BDD0FB"
      />
    </g>
    <path
      d="M44.712 27.4348C44.5881 27.3438 44.4198 27.3408 44.2929 27.4276L40.6715 29.9036C38.7868 29.0962 36.7592 28.5818 34.6544 28.4111L32.6236 24.5373C32.5524 24.4014 32.4024 24.3255 32.2501 24.3482L27.0377 25.1252C26.8853 25.148 26.7643 25.2643 26.7362 25.4149L25.9356 29.7108C23.9736 30.4879 22.1864 31.5708 20.6224 32.8924L16.4307 31.5811C16.2838 31.5352 16.1237 31.587 16.0322 31.7102L12.8987 35.9268C12.8071 36.0502 12.8042 36.2176 12.8915 36.3438L15.38 39.947C14.5684 41.8222 14.0516 43.8397 13.8799 45.9339L9.98654 47.9546C9.84996 48.0254 9.7737 48.1746 9.79647 48.3262L10.5774 53.5124C10.6002 53.664 10.7172 53.7845 10.8686 53.8123L15.1862 54.6089C15.9671 56.5611 17.0554 58.3393 18.3838 59.8955L17.0659 64.0662C17.0198 64.2123 17.0718 64.3716 17.1956 64.4627L21.4336 67.5804C21.5574 67.6716 21.7258 67.6744 21.8527 67.5877L25.474 65.1116C27.3587 65.9191 29.3864 66.4334 31.4912 66.6042L33.522 70.478C33.5932 70.6139 33.7432 70.6899 33.8955 70.6672L39.1079 69.8901C39.2603 69.8674 39.3813 69.751 39.4094 69.6003L40.2099 65.3045C42.172 64.5274 43.9591 63.4445 45.5232 62.1228L49.7148 63.434C49.8617 63.4801 50.0219 63.4282 50.1134 63.305L53.2468 59.0883C53.3384 58.9651 53.3413 58.7976 53.2541 58.6713L50.7656 55.0681C51.5772 53.1929 52.094 51.1754 52.2657 49.0812L56.1591 47.0606C56.2956 46.9899 56.372 46.8405 56.3491 46.6889L55.5681 41.5028C55.5453 41.3512 55.4284 41.2307 55.2769 41.2028L50.9594 40.4062C50.1784 38.4541 49.09 36.676 47.7617 35.1197L49.0796 30.949C49.1258 30.8028 49.0737 30.6437 48.9499 30.5525L44.712 27.4348Z"
      fill="#BDD0FB"
    />
    <path
      d="M31.767 42.3985C34.2694 41.7636 36.9353 43.0345 37.9605 45.4742C39.0873 48.156 37.8113 51.2496 35.1162 52.3708C33.8105 52.9143 32.3704 52.9187 31.0615 52.3842C29.7524 51.8498 28.7307 50.84 28.1849 49.5409C27.0581 46.8591 28.3341 43.7655 31.0292 42.6443C31.2722 42.5433 31.5189 42.4615 31.767 42.3985ZM34.0682 51.4266C34.2614 51.3776 34.4522 51.3143 34.6396 51.2364C36.706 50.3769 37.6842 48.0046 36.8204 45.9487C35.9564 43.8926 33.5726 42.9182 31.5058 43.7787C29.4395 44.6382 28.4613 47.0105 29.325 49.0664C29.7437 50.0626 30.5269 50.8367 31.5307 51.2466C32.3465 51.5796 33.229 51.6395 34.0682 51.4266Z"
      fill="url(#paint0_linear_5708_65144)"
    />
    <path
      d="M29.7716 35.0475C30.2014 34.9384 30.6392 34.8502 31.0838 34.7839C31.2238 34.763 31.3641 34.7445 31.5047 34.728C32.1979 34.6472 32.8964 34.6214 33.5895 34.651C33.599 34.6514 33.6084 34.6518 33.6178 34.6522C33.6446 34.6535 33.6714 34.6548 33.6983 34.6563C33.7505 34.6588 33.8027 34.662 33.8548 34.6652C33.9918 34.6738 34.1023 34.77 34.1346 34.8957C34.1424 34.9262 34.1456 34.9586 34.1435 34.9917C34.1327 35.1611 33.9856 35.2892 33.8155 35.2787C32.9391 35.2232 32.051 35.2613 31.1757 35.3921C26.827 36.0396 23.3407 38.8723 21.673 42.6006C20.745 44.6742 20.3801 47.0251 20.7425 49.4315C20.806 49.8536 20.8904 50.2692 20.9951 50.6771C21.6989 53.422 23.3166 55.8225 25.6368 57.5293C28.3019 59.49 31.575 60.3007 34.8527 59.8121C41.6222 58.8022 46.2996 52.505 45.2858 45.7727C45.2233 45.3576 45.14 44.9471 45.0362 44.5431C44.5872 42.7922 43.7581 41.1585 42.6027 39.7622C42.5728 39.7261 42.5526 39.6854 42.5419 39.6429C42.5132 39.5311 42.5493 39.4077 42.6448 39.3296C42.7769 39.222 42.9712 39.24 43.0798 39.3716C44.2929 40.8376 45.1635 42.5528 45.6349 44.3909C45.7437 44.815 45.8312 45.2458 45.897 45.6814C46.9615 52.7498 42.0459 59.3615 34.9444 60.4203C31.5032 60.9333 28.0674 60.0821 25.2696 58.0237C22.8337 56.2319 21.1355 53.7118 20.3965 50.8302C20.2868 50.4019 20.1982 49.9656 20.1313 49.5228C19.6158 46.0987 20.4711 42.68 22.5398 39.8962C24.3409 37.4722 26.8748 35.7825 29.7716 35.0475Z"
      fill="url(#paint1_linear_5708_65144)"
    />
    <g opacity="0.3">
      <path
        d="M81.5624 10.0107C81.7626 9.96001 81.9802 10.0431 82.0908 10.2289C82.2976 10.5755 82.4966 10.9331 82.6822 11.2917C82.8028 11.5247 82.7106 11.8107 82.4761 11.931C82.2418 12.0521 81.9538 11.9591 81.8332 11.7261C81.6563 11.3844 81.4667 11.0435 81.2694 10.7127C81.135 10.4875 81.2099 10.1963 81.4366 10.0623C81.477 10.0386 81.5193 10.0217 81.5624 10.0107Z"
        fill="#BDD0FB"
      />
      <path
        d="M83.1356 13.3096C83.3699 13.2502 83.616 13.3757 83.7008 13.6063C83.9409 14.2577 84.15 14.929 84.3222 15.6009C84.3584 15.7424 84.3932 15.8848 84.4268 16.0279C84.4863 16.2836 84.3106 16.5324 84.0702 16.5982C83.8136 16.6576 83.5572 16.4987 83.4973 16.2436C83.4654 16.1068 83.4322 15.9707 83.3976 15.8355C83.2333 15.1945 83.0339 14.5543 82.8052 13.933C82.7144 13.6867 82.8415 13.4143 83.0888 13.3238C83.1044 13.3184 83.12 13.3135 83.1356 13.3096ZM84.2578 18.1102C84.2796 18.1047 84.3024 18.1004 84.3253 18.0979C84.5874 18.0701 84.8226 18.2588 84.8507 18.5195C84.9409 19.3558 84.9797 20.2052 84.966 21.0435C84.9618 21.3057 84.7434 21.5143 84.4812 21.5104C84.2176 21.506 84.0078 21.2904 84.012 21.0282C84.025 20.2283 83.9879 19.4182 83.902 18.6206C83.8764 18.383 84.0316 18.1676 84.2578 18.1102ZM84.1764 23.0382C84.2351 23.0233 84.2975 23.0195 84.3611 23.0282C84.622 23.0649 84.8034 23.3054 84.7665 23.565C84.6478 24.3964 84.4758 25.2299 84.2544 26.0414C84.1854 26.2948 83.9241 26.4439 83.6689 26.3751C83.4148 26.3066 83.2645 26.0457 83.3334 25.7929C83.5444 25.0189 83.7087 24.2247 83.8216 23.4316C83.8497 23.2354 83.9947 23.0843 84.1764 23.0382ZM82.8798 27.7957C82.9755 27.7714 83.0794 27.7766 83.1778 27.8163C83.4215 27.9156 83.5386 28.1931 83.4387 28.4356C83.1183 29.2144 82.7467 29.9799 82.3336 30.7113C82.2044 30.9398 81.9132 31.0204 81.6841 30.8924C81.4543 30.7642 81.3727 30.4749 81.5018 30.246C81.8956 29.549 82.2503 28.8185 82.5557 28.076C82.6152 27.9312 82.7382 27.8316 82.8798 27.7957ZM80.4547 32.0937C80.5884 32.0598 80.7359 32.0836 80.8557 32.1713C81.0679 32.3265 81.1132 32.6236 80.9573 32.8349C80.4566 33.5116 79.9094 34.1642 79.3305 34.7742C79.1497 34.9655 78.8477 34.9737 78.6561 34.7936C78.4645 34.6135 78.4557 34.313 78.6365 34.1226C79.1889 33.5404 79.7109 32.9181 80.1884 32.2722C80.2565 32.1803 80.3516 32.1198 80.4547 32.0937ZM77.0552 35.6753C77.2283 35.6314 77.4195 35.6868 77.5411 35.8329C77.7089 36.0348 77.6803 36.3339 77.4774 36.501C76.8266 37.0364 76.1359 37.5365 75.4248 37.9867C75.2014 38.1272 74.9075 38.062 74.766 37.841C74.6246 37.62 74.6902 37.3264 74.9123 37.1858C75.5906 36.7563 76.2488 36.2798 76.8692 35.7694C76.9254 35.7231 76.9891 35.6921 77.0552 35.6753ZM72.8799 38.3206C73.0966 38.2656 73.3291 38.3688 73.4284 38.5771C73.5413 38.8139 73.4397 39.0971 73.2018 39.2095C72.4413 39.5685 71.6481 39.8845 70.8443 40.1492C70.5922 40.2275 70.3239 40.0961 70.2414 39.8473C70.1587 39.5985 70.2944 39.3301 70.5445 39.2475C71.3115 38.9955 72.0679 38.694 72.7929 38.3517C72.8214 38.3383 72.8506 38.3281 72.8799 38.3206ZM65.7174 40.2C65.7441 40.1932 65.772 40.1885 65.8005 40.1866C66.4941 40.1354 67.1972 40.0456 67.8902 39.9195C67.9952 39.901 68.0982 39.8815 68.2006 39.8608C68.4592 39.8096 68.7105 39.9759 68.7622 40.233C68.8144 40.4906 68.6468 40.7483 68.3883 40.7919C68.2789 40.8135 68.1696 40.8345 68.0594 40.8539C67.3354 40.9854 66.5984 41.0796 65.8709 41.1331C65.608 41.1524 65.3794 40.9563 65.36 40.6948C65.3427 40.462 65.4973 40.2558 65.7174 40.2Z"
        fill="#BDD0FB"
      />
    </g>
    <g opacity="0.3">
      <path
        d="M58.9978 0.889982C59.2502 0.825961 59.5083 0.975802 59.5763 1.22691C59.6447 1.47985 59.4939 1.74058 59.2395 1.80847C58.4734 2.01336 57.7134 2.2665 56.9806 2.56094C56.737 2.65625 56.4581 2.54189 56.3595 2.29851C56.2608 2.05519 56.3792 1.77874 56.6233 1.68049C57.3919 1.3721 58.1885 1.1064 58.9915 0.891618C58.9935 0.891095 58.9958 0.890506 58.9978 0.889982ZM61.3887 0.401578C61.4054 0.397323 61.4221 0.394051 61.4395 0.391564C62.2615 0.273865 63.0992 0.204869 63.9291 0.186147C64.1926 0.180518 64.4109 0.387766 64.4168 0.649872C64.423 0.91237 64.2126 1.12892 63.9508 1.13553C63.1589 1.15327 62.3596 1.21918 61.5751 1.33119C61.3144 1.36863 61.0725 1.18835 61.0351 0.928998C61.0001 0.686268 61.1557 0.460689 61.3887 0.401578ZM54.4812 2.70567C54.6862 2.6537 54.9085 2.74272 55.0161 2.93544C55.1438 3.16423 55.0609 3.45324 54.8305 3.58056C54.1366 3.96423 53.4605 4.3926 52.8208 4.85495C52.6065 5.00833 52.3092 4.96178 52.1545 4.74936C51.9997 4.53747 52.0471 4.24034 52.2603 4.08624C52.9309 3.60177 53.6399 3.15258 54.3673 2.75084C54.4042 2.73048 54.4423 2.71556 54.4812 2.70567ZM66.2616 0.295204C66.3142 0.28185 66.37 0.277268 66.4272 0.282832C67.2542 0.365313 68.0843 0.499639 68.8944 0.682079C69.1515 0.739815 69.3127 0.994066 69.2546 1.24989C69.1964 1.50479 68.9409 1.6653 68.6841 1.60796C67.9116 1.43416 67.1203 1.30631 66.3318 1.22743C66.0697 1.20112 65.8783 0.968404 65.9048 0.707673C65.9254 0.503959 66.073 0.343122 66.2616 0.295204ZM50.54 5.55368C50.7036 5.51218 50.8845 5.55853 51.0074 5.69004C51.1873 5.88217 51.1763 6.1825 50.9835 6.36108C50.4038 6.89753 49.8513 7.47496 49.3411 8.07805C49.1713 8.27902 48.8702 8.30422 48.6688 8.13527C48.4672 7.96631 48.4414 7.6667 48.6112 7.46626C49.1464 6.83436 49.7256 6.22865 50.3331 5.66595C50.3938 5.60991 50.4653 5.57267 50.54 5.55368ZM47.4004 9.25936C47.5257 9.22755 47.6633 9.24627 47.7797 9.32201C48.0002 9.46557 48.0622 9.75981 47.9179 9.97917C47.4834 10.6401 47.0854 11.3328 46.735 12.0379C46.6182 12.2732 46.3317 12.3694 46.0959 12.2532C45.8596 12.137 45.763 11.8525 45.8797 11.6177C46.2469 10.8781 46.664 10.1519 47.1193 9.45941C47.1872 9.35605 47.2889 9.28764 47.4004 9.25936ZM45.2433 13.6071C45.3313 13.5848 45.4266 13.5869 45.5188 13.6195C45.7675 13.7061 45.8983 13.9772 45.811 14.2246C45.5477 14.9693 45.3285 15.7369 45.1593 16.5054C45.1027 16.7609 44.8484 16.9235 44.5911 16.8672C44.3337 16.8111 44.1708 16.5582 44.2272 16.3018C44.4049 15.496 44.6347 14.691 44.9104 13.9096C44.9655 13.754 45.0938 13.645 45.2433 13.6071Z"
        fill="#BDD0FB"
      />
      <path
        d="M71.0363 1.37066C71.1254 1.34801 71.2221 1.35082 71.3152 1.38407C71.6995 1.52148 72.0814 1.67099 72.4505 1.82797C72.6926 1.93113 72.8052 2.21019 72.7016 2.45128C72.5975 2.69153 72.3176 2.80373 72.0751 2.70108C71.7232 2.55118 71.3588 2.40873 70.9922 2.27735C70.7442 2.18865 70.6156 1.91653 70.7048 1.67001C70.7606 1.51617 70.8879 1.4083 71.0363 1.37066Z"
        fill="#BDD0FB"
      />
    </g>
    <path
      d="M72.1748 7.41037C72.0919 7.34943 71.9793 7.34746 71.8944 7.40553L69.4711 9.06234C68.21 8.52203 66.8531 8.17784 65.4447 8.06361L64.0858 5.47148C64.0381 5.38056 63.9377 5.32976 63.8358 5.34495L60.348 5.8649C60.246 5.88016 60.1651 5.95799 60.1462 6.0588L59.6105 8.93339C58.2976 9.45334 57.1017 10.178 56.0551 11.0624L53.2502 10.1849C53.1519 10.1542 53.0448 10.1889 52.9835 10.2713L50.8867 13.0928C50.8254 13.1753 50.8235 13.2874 50.8818 13.3719L52.547 15.783C52.0039 17.0378 51.6581 18.3878 51.5432 19.7892L48.938 21.1412C48.8466 21.1887 48.7955 21.2885 48.8108 21.3899L49.3334 24.8603C49.3486 24.9618 49.4269 25.0423 49.5282 25.061L52.4174 25.5941C52.94 26.9004 53.6683 28.0903 54.5571 29.1316L53.6753 31.9224C53.6444 32.0202 53.6792 32.1268 53.762 32.1877L56.5979 34.274C56.6807 34.335 56.7934 34.3369 56.8783 34.2788L59.3016 32.6219C60.5627 33.1623 61.9196 33.5064 63.328 33.6207L64.6869 36.2129C64.7345 36.3037 64.8349 36.3546 64.9368 36.3394L68.4248 35.8194C68.5267 35.8043 68.6077 35.7264 68.6265 35.6256L69.1622 32.751C70.4751 32.231 71.671 31.5064 72.7176 30.622L75.5224 31.4994C75.6208 31.5302 75.7279 31.4955 75.7891 31.413L77.8859 28.5914C77.9472 28.509 77.9491 28.397 77.8908 28.3124L76.2256 25.9013C76.7687 24.6465 77.1145 23.2965 77.2293 21.8951L79.8346 20.543C79.926 20.4957 79.9771 20.3957 79.9618 20.2943L79.4392 16.824C79.4239 16.7225 79.3457 16.6419 79.2444 16.6232L76.3552 16.0902C75.8326 14.7839 75.1043 13.594 74.2155 12.5527L75.0974 9.76179C75.1283 9.66393 75.0935 9.55743 75.0106 9.49642L72.1748 7.41037Z"
      fill="#BDD0FB"
    />
    <path
      d="M63.5018 17.3602C64.2475 17.1711 65.0314 17.2242 65.7564 17.5202C66.648 17.8843 67.3439 18.5722 67.7156 19.4572C68.4832 21.2832 67.6142 23.3904 65.7784 24.1547C63.9387 24.9161 61.8242 24.0533 61.0568 22.2268C60.6848 21.3419 60.6816 20.3658 61.0475 19.4788C61.4134 18.5914 62.1048 17.8989 62.9944 17.5291C63.1607 17.4601 63.3304 17.4037 63.5018 17.3602ZM65.0407 23.4018C65.1651 23.3703 65.2885 23.3294 65.4104 23.2788C66.7607 22.7167 67.3998 21.1667 66.8353 19.8231C66.5618 19.1725 66.05 18.6661 65.3942 18.3986C64.738 18.1307 64.0168 18.1338 63.3622 18.4051C62.7081 18.6773 62.1994 19.1866 61.9303 19.8391C61.6611 20.492 61.6635 21.2099 61.9371 21.861C62.4506 23.083 63.7868 23.72 65.0407 23.4018Z"
      fill="url(#paint2_linear_5708_65144)"
    />
    <path
      d="M62.1197 12.242C62.4123 12.1678 62.7108 12.1079 63.0155 12.0621C63.6205 11.9718 64.2354 11.9425 64.8446 11.9755C64.872 11.9772 64.8994 11.9789 64.9267 11.9806C65.1384 11.9939 65.3089 12.1424 65.3589 12.3364C65.371 12.3836 65.3758 12.4335 65.3725 12.4846C65.3559 12.7461 65.1286 12.9436 64.8661 12.9279C64.2976 12.8917 63.7228 12.9166 63.1573 13.0012L63.1571 13.0012C63.126 13.0058 63.0949 13.0109 63.0642 13.0158C61.7278 13.2281 60.4953 13.7637 59.4511 14.5644C58.8843 14.999 58.3731 15.5125 57.9314 16.0957C57.9278 16.1004 57.9242 16.1052 57.9206 16.1099C57.9097 16.1246 57.8987 16.1389 57.888 16.1536C56.6125 17.8703 56.0849 19.9785 56.4029 22.0898C56.4439 22.3631 56.4986 22.6319 56.5663 22.8961C57.022 24.673 58.0694 26.227 59.5714 27.3323C61.2968 28.6015 63.4155 29.126 65.5373 28.8097C67.6577 28.4927 69.5304 27.3737 70.8064 25.6573C72.0819 23.9407 72.6095 21.8325 72.2915 19.7211C72.2512 19.4525 72.1971 19.1868 72.1301 18.9254C71.8393 17.7917 71.3027 16.7342 70.5547 15.8304C70.5086 15.7746 70.4774 15.7118 70.4608 15.6461C70.4166 15.4736 70.4723 15.283 70.6197 15.1623C70.8236 14.9962 71.1237 15.0244 71.2915 15.2272C72.1284 16.2386 72.729 17.422 73.0545 18.6899C73.1295 18.9827 73.1901 19.2798 73.2353 19.5803C73.591 21.9428 73.0009 24.3012 71.5735 26.2219C70.1463 28.1422 68.0545 29.3963 65.679 29.7487C63.3049 30.1028 60.9346 29.5158 59.0043 28.0954C57.3237 26.8593 56.152 25.1206 55.6423 23.1325C55.5667 22.8374 55.5053 22.5362 55.4594 22.2308C54.7707 17.6572 57.7095 13.361 62.1197 12.242Z"
      fill="url(#paint3_linear_5708_65144)"
    />
    <path
      d="M8.13144 167H42.8459V92.6655H6.69824V165.574C6.69824 166.361 7.33991 167 8.13144 167Z"
      fill="#7D97F4"
    />
    <path
      d="M1.85682 99.4291H44.5672L46.6494 76.2764L11.0016 76.5893L0.174337 97.5133C-0.395746 98.4071 0.501846 99.4291 1.85682 99.4291Z"
      fill="url(#paint4_linear_5708_65144)"
    />
    <path
      d="M10.7959 77.1329L44.3106 76.7047L46.6492 73.7075H12.8833C11.7305 73.7075 10.7959 74.6374 10.7959 75.7844V77.1329Z"
      fill="url(#paint5_linear_5708_65144)"
    />
    <path
      d="M42.123 171.496V65.4714L106.735 29.4995L168.737 67.2196V171.707L42.123 171.496Z"
      fill="#91B3FA"
    />
    <path
      d="M133.629 82.0181H133.376C126.787 82.0181 121.019 86.6594 121.019 93.2151V105.021H133.629V82.0181Z"
      fill="#7D97F4"
    />
    <path
      d="M121.019 108.507V143.241C121.019 144.41 122.399 146.223 123.574 146.223H133.63V108.507H121.019Z"
      fill="#7D97F4"
    />
    <path
      d="M137.073 82.0181H136.432V105.021H149.043V93.2152C149.043 86.6594 143.662 82.0181 137.073 82.0181Z"
      fill="#7D97F4"
    />
    <path
      d="M136.432 146.223H146.875C148.05 146.223 149.043 144.41 149.043 143.241V108.507H136.432V146.223Z"
      fill="#7D97F4"
    />
    <path
      d="M150.133 148.393H119.777C118.036 148.393 116.62 146.984 116.62 145.252V92.9567C116.62 84.6869 123.382 77.959 131.694 77.959H138.217C146.528 77.959 153.29 84.6869 153.29 92.9567V145.252C153.29 146.984 151.874 148.393 150.133 148.393ZM131.694 78.2499C123.543 78.2499 116.913 84.8473 116.913 92.9567V145.252C116.913 146.824 118.198 148.102 119.777 148.102H150.133C151.713 148.102 152.998 146.824 152.998 145.252V92.9567C152.998 84.8472 146.367 78.2499 138.217 78.2499H131.694Z"
      fill="url(#paint6_linear_5708_65144)"
    />
    <path
      opacity="0.9"
      d="M74.9598 81.3179H74.7063C68.1174 81.3179 62.3491 85.9592 62.3491 92.515V104.321H74.9598V81.3179Z"
      fill="#7D97F4"
    />
    <path
      opacity="0.9"
      d="M62.3491 107.807V142.54C62.3491 143.71 63.729 145.523 64.9045 145.523H74.9598V107.807H62.3491Z"
      fill="#7D97F4"
    />
    <path
      opacity="0.9"
      d="M78.4031 81.3179H77.7622V104.321H90.3728V92.515C90.3728 85.9592 84.992 81.3179 78.4031 81.3179Z"
      fill="#7D97F4"
    />
    <path
      opacity="0.9"
      d="M77.7622 145.523H88.2049C89.3803 145.523 90.3728 143.71 90.3728 142.54V107.807H77.7622V145.523Z"
      fill="#7D97F4"
    />
    <path
      d="M91.4772 147.693H61.1206C59.3799 147.693 57.9639 146.284 57.9639 144.552V92.2565C57.9639 83.9867 64.7258 77.2588 73.0373 77.2588H79.5603C87.8718 77.2588 94.6339 83.9867 94.6339 92.2565V144.552C94.6339 146.284 93.2179 147.693 91.4772 147.693ZM73.0374 77.5496C64.887 77.5496 58.2563 84.147 58.2563 92.2565V144.552C58.2563 146.123 59.5414 147.402 61.1207 147.402H91.4772C93.0565 147.402 94.3416 146.123 94.3416 144.552V92.2565C94.3416 84.147 87.7107 77.5496 79.5604 77.5496H73.0374Z"
      fill="url(#paint7_linear_5708_65144)"
    />
    <path
      d="M58.2065 74.8196C55.1957 74.5187 52.3867 72.9135 49.7447 71.353C39.912 65.5451 47.6183 61.3743 54.3984 58.1975C65.1056 53.1808 75.4541 47.2461 85.3583 40.8105C88.3829 38.8452 91.441 36.7865 94.9332 35.8667C99.5244 34.6573 109.382 37.1434 107.846 43.78C107.266 46.2851 104.581 47.6621 103.154 49.8054C100.787 53.3622 102.275 58.2313 100.891 62.2695C98.3745 69.6085 90.04 70.4869 83.3413 70.7636C79.3229 70.9295 75.0381 70.47 71.0754 71.2463C67.1028 72.0247 63.6531 74.7201 59.5335 74.8639C59.0868 74.8796 58.6445 74.8634 58.2065 74.8196Z"
      fill="url(#paint8_linear_5708_65144)"
    />
    <path
      d="M103.926 21.3753L31.3177 65.949C30.1965 66.6374 29.9718 67.8794 30.8062 68.7766C34.0543 72.2691 40.4609 72.937 44.8027 70.2357L104.379 33.1698C105.387 32.5429 106.832 32.5547 107.822 33.1979L165.559 70.7005C169.367 73.1744 175.083 72.7451 178.196 69.7512L179.198 68.7867C180.125 67.8956 179.942 66.5972 178.789 65.8792L107.312 21.3841C106.326 20.7705 104.918 20.7668 103.926 21.3753Z"
      fill="url(#paint9_linear_5708_65144)"
    />
    <path
      d="M85.0991 18.4093C85.1703 18.4559 85.2471 18.3594 85.1858 18.3004C82.7178 15.9213 73.236 7.61532 63.8018 10.4534C52.8335 13.753 61.9249 21.2226 69.772 17.3948C76.69 14.0202 82.8171 16.9141 85.0991 18.4093Z"
      fill="url(#paint10_linear_5708_65144)"
    />
    <path
      opacity="0.7"
      d="M60.3876 13.2022C60.3814 13.2075 60.4524 13.1437 60.5608 13.0579C60.6712 12.9713 60.8341 12.8515 61.0462 12.7111C61.4706 12.4324 62.1008 12.0807 62.8985 11.7651C63.6968 11.4544 64.6612 11.1796 65.7151 11.034C66.2407 10.9552 66.7883 10.9141 67.344 10.8966C67.6219 10.8954 67.9022 10.8836 68.1826 10.8988L68.6041 10.9131L69.0251 10.9448C69.306 10.9623 69.585 10.9964 69.8625 11.0329C70.1411 11.0624 70.4148 11.1135 70.6869 11.1596C70.9602 11.201 71.2264 11.2636 71.4908 11.3201C71.756 11.3728 72.0137 11.4408 72.267 11.5085C72.5209 11.5731 72.7698 11.6397 73.0094 11.7177C73.2494 11.7941 73.4873 11.8595 73.7131 11.9401C74.1649 12.0997 74.5934 12.247 74.9783 12.4091C75.1717 12.4873 75.3571 12.5622 75.5335 12.6335C75.707 12.711 75.8718 12.7845 76.0263 12.8536C76.1808 12.9227 76.3256 12.9874 76.4594 13.0471C76.5909 13.1116 76.7116 13.1708 76.8208 13.2243C77.2565 13.4391 77.5056 13.5619 77.5056 13.5619C77.6077 13.6122 77.6493 13.7354 77.5988 13.837C77.5489 13.9369 77.4285 13.9787 77.3275 13.9322L77.3202 13.9288C77.3202 13.9288 77.0716 13.8141 76.6366 13.6134C76.5276 13.5635 76.4073 13.5082 76.276 13.448C76.1427 13.3926 75.9987 13.3327 75.8448 13.2686C75.6912 13.2046 75.5274 13.1365 75.3548 13.0647C75.1799 12.9992 74.996 12.9303 74.8041 12.8585C74.4221 12.709 73.999 12.5759 73.5531 12.431C73.3304 12.3578 73.0964 12.3002 72.8606 12.2317C72.6247 12.1614 72.3805 12.1029 72.1316 12.0464C71.8837 11.9869 71.6312 11.9271 71.3728 11.8828C71.115 11.8346 70.8552 11.7803 70.59 11.7473C70.3255 11.7096 70.0597 11.6668 69.7905 11.6455C69.5219 11.6172 69.2524 11.5911 68.9819 11.5814L68.5771 11.5612L68.1728 11.558C67.9038 11.5502 67.6367 11.5688 67.3716 11.5765C66.8421 11.6069 66.3229 11.6592 65.8274 11.7468C64.8337 11.9101 63.9365 12.1923 63.2014 12.5001C62.4672 12.8128 61.8972 13.1517 61.5226 13.4116C61.336 13.5423 61.1965 13.6509 61.1057 13.7259C61.0139 13.8031 60.9834 13.8327 60.9774 13.8381C60.801 14.0001 60.526 13.9891 60.363 13.8135C60.1999 13.6379 60.211 13.3642 60.3876 13.2022Z"
      fill="white"
    />
    <path
      d="M7.80127 129.505H73.8779V124.282H7.80127V129.505Z"
      fill="url(#paint11_linear_5708_65144)"
    />
    <path
      d="M69.9824 148.046H74.0527V124.048C74.0527 123.691 73.7615 123.401 73.4024 123.401H70.5638C70.2428 123.401 69.9824 123.66 69.9824 123.979V148.046Z"
      fill="url(#paint12_linear_5708_65144)"
    />
    <path
      d="M6.91553 148.046H10.9858V123.816C10.9858 123.587 10.7988 123.401 10.5681 123.401H7.47568C7.16633 123.401 6.91553 123.65 6.91553 123.958V148.046Z"
      fill="url(#paint13_linear_5708_65144)"
    />
    <path
      d="M26.0884 140.572L42.264 151.474L56.2531 93.6332L52.244 91.5171L26.0884 140.572Z"
      fill="url(#paint14_linear_5708_65144)"
    />
    <path
      d="M42.4312 150.782L56.2528 93.6332L55.0597 93.0034L40.1252 152.594L42.4312 150.782Z"
      fill="#7D97F4"
    />
    <path
      d="M26.538 138.765L17.9266 154.916C17.6629 155.411 18.0073 156.045 18.6107 156.176L25.4703 157.662C25.6133 157.693 25.7493 157.756 25.8667 157.844L35.4408 165.048C35.9164 165.406 36.5867 165.278 36.8079 164.787L43.3798 150.2C43.5258 149.876 37.7219 140.786 36.5163 138.903C36.3801 138.691 36.1469 138.56 35.8936 138.555C34.0751 138.514 26.746 138.375 26.538 138.765ZM25.8683 148.845C26.3137 148.177 27.212 147.984 27.8944 148.409C30.7327 150.177 34.2088 152.48 35.8347 153.564C36.3734 153.924 36.59 154.607 36.3565 155.209L34.7467 159.359C34.679 159.533 34.3167 159.508 34.0075 159.308L27.7838 155.28C27.7075 155.231 27.6238 155.19 27.5396 155.161L23.5063 153.769C23.1516 153.647 22.8842 153.349 22.9753 153.178L25.8683 148.845Z"
      fill="url(#paint15_linear_5708_65144)"
    />
    <path
      d="M10.5068 130.716L11.9606 130.097C12.1348 130.023 12.2155 129.822 12.1409 129.649L11.5185 128.203C11.4439 128.029 11.2423 127.949 11.0681 128.023L9.61438 128.643C9.44017 128.717 9.35944 128.917 9.43405 129.091L10.0564 130.537C10.131 130.71 10.3327 130.791 10.5068 130.716Z"
      fill="url(#paint16_linear_5708_65144)"
    />
    <path
      d="M24.1573 168.017L28.692 166.086L14.1134 132.207L9.57861 134.139L24.1573 168.017Z"
      fill="url(#paint17_linear_5708_65144)"
    />
    <path
      d="M4.43162 131.859L15.271 127.242L17.0957 131.482L6.25627 136.1L1.14172 136.315L0.784668 135.485L4.43162 131.859Z"
      fill="url(#paint18_linear_5708_65144)"
    />
    <path
      d="M64.2243 103.204L71.2747 107.62C71.664 107.864 71.781 108.376 71.5359 108.763L43.1311 153.659C42.8859 154.046 42.3716 154.163 41.9822 153.919L34.9319 149.503C34.5425 149.259 34.4256 148.747 34.6706 148.36L63.0755 103.464C63.3205 103.077 63.8349 102.96 64.2243 103.204Z"
      fill="url(#paint19_linear_5708_65144)"
    />
    <path
      d="M64.5734 104.43L70.1331 107.913C70.3667 108.059 70.4386 108.364 70.2936 108.593L42.5635 152.422C42.3218 152.804 41.7848 152.956 41.3955 152.712L36.3998 149.583C36.0105 149.339 35.916 148.792 36.1577 148.41L63.8878 104.58C64.0328 104.351 64.3397 104.284 64.5734 104.43Z"
      fill="url(#paint20_linear_5708_65144)"
    />
    <path
      d="M63.3506 104.364C63.2735 104.486 63.3103 104.647 63.4327 104.723L66.9781 106.944C67.1004 107.02 67.2621 106.984 67.3391 106.862L67.3644 106.822C67.4415 106.7 67.4047 106.539 67.2823 106.463L63.737 104.242C63.6147 104.166 63.453 104.202 63.376 104.324L63.3506 104.364Z"
      fill="url(#paint21_linear_5708_65144)"
    />
    <path
      d="M62.6782 105.426C62.5942 105.559 62.6343 105.735 62.7678 105.818L64.5807 106.954C64.7142 107.037 64.8906 106.997 64.9746 106.865C65.0586 106.732 65.0185 106.556 64.8851 106.473L63.0721 105.337C62.9386 105.254 62.7622 105.293 62.6782 105.426Z"
      fill="url(#paint22_linear_5708_65144)"
    />
    <path
      d="M61.9936 106.509C61.9096 106.642 61.9497 106.817 62.0832 106.901L63.8961 108.036C64.0296 108.12 64.206 108.08 64.29 107.947C64.3741 107.814 64.334 107.639 64.2005 107.555L62.3875 106.42C62.2541 106.336 62.0777 106.376 61.9936 106.509Z"
      fill="url(#paint23_linear_5708_65144)"
    />
    <path
      d="M61.3088 107.591C61.2248 107.724 61.2649 107.899 61.3984 107.983L63.2113 109.118C63.3448 109.202 63.5212 109.162 63.6052 109.029C63.6892 108.896 63.6492 108.721 63.5157 108.637L61.7027 107.502C61.5692 107.418 61.3928 107.458 61.3088 107.591Z"
      fill="url(#paint24_linear_5708_65144)"
    />
    <path
      d="M60.624 108.673C60.54 108.806 60.5801 108.982 60.7136 109.065L62.5265 110.201C62.66 110.284 62.8364 110.245 62.9204 110.112C63.0045 109.979 62.9644 109.803 62.8309 109.72L61.0179 108.584C60.8844 108.501 60.708 108.541 60.624 108.673Z"
      fill="url(#paint25_linear_5708_65144)"
    />
    <path
      d="M59.6221 110.257C59.545 110.378 59.5818 110.539 59.7042 110.616L63.2495 112.836C63.3719 112.913 63.5336 112.877 63.6106 112.755L63.6359 112.715C63.713 112.593 63.6762 112.432 63.5538 112.355L60.0085 110.135C59.8861 110.058 59.7244 110.095 59.6474 110.217L59.6221 110.257Z"
      fill="url(#paint26_linear_5708_65144)"
    />
    <path
      d="M58.9502 111.319C58.8662 111.452 58.9062 111.627 59.0397 111.711L60.8527 112.846C60.9862 112.93 61.1625 112.89 61.2466 112.757C61.3306 112.624 61.2905 112.449 61.157 112.365L59.3441 111.23C59.2106 111.146 59.0342 111.186 58.9502 111.319Z"
      fill="url(#paint27_linear_5708_65144)"
    />
    <path
      d="M58.2654 112.401C58.1814 112.534 58.2214 112.709 58.3549 112.793L60.1679 113.928C60.3014 114.012 60.4777 113.972 60.5618 113.839C60.6458 113.706 60.6057 113.531 60.4722 113.447L58.6593 112.312C58.5258 112.228 58.3494 112.268 58.2654 112.401Z"
      fill="url(#paint28_linear_5708_65144)"
    />
    <path
      d="M57.5806 113.483C57.4965 113.616 57.5366 113.792 57.6701 113.875L59.483 115.011C59.6165 115.094 59.7929 115.055 59.8769 114.922C59.961 114.789 59.9209 114.613 59.7874 114.53L57.9744 113.394C57.841 113.311 57.6646 113.351 57.5806 113.483Z"
      fill="url(#paint29_linear_5708_65144)"
    />
    <path
      d="M56.896 114.566C56.8119 114.699 56.8521 114.874 56.9856 114.958L58.7985 116.093C58.932 116.177 59.1084 116.137 59.1924 116.004C59.2764 115.871 59.2363 115.696 59.1029 115.612L57.2899 114.477C57.1564 114.393 56.98 114.433 56.896 114.566Z"
      fill="url(#paint30_linear_5708_65144)"
    />
    <path
      d="M55.8945 116.149C55.8175 116.27 55.8543 116.431 55.9766 116.508L59.5219 118.728C59.6443 118.805 59.806 118.769 59.883 118.647L59.9083 118.607C59.9854 118.485 59.9486 118.324 59.8262 118.247L56.2809 116.027C56.1585 115.95 55.9968 115.987 55.9198 116.109L55.8945 116.149Z"
      fill="url(#paint31_linear_5708_65144)"
    />
    <path
      d="M55.2222 117.211C55.1381 117.344 55.1782 117.519 55.3117 117.603L57.1246 118.738C57.2581 118.822 57.4345 118.782 57.5185 118.649C57.6026 118.516 57.5625 118.341 57.429 118.257L55.616 117.122C55.4826 117.038 55.3062 117.078 55.2222 117.211Z"
      fill="url(#paint32_linear_5708_65144)"
    />
    <path
      d="M54.5374 118.293C54.4533 118.426 54.4934 118.601 54.6269 118.685L56.4399 119.82C56.5734 119.904 56.7497 119.864 56.8338 119.731C56.9178 119.599 56.8777 119.423 56.7442 119.339L54.9313 118.204C54.7978 118.12 54.6214 118.16 54.5374 118.293Z"
      fill="url(#paint33_linear_5708_65144)"
    />
    <path
      d="M53.8528 119.375C53.7688 119.508 53.8088 119.684 53.9423 119.767L55.7553 120.903C55.8888 120.987 56.0651 120.947 56.1492 120.814C56.2332 120.681 56.1931 120.506 56.0596 120.422L54.2467 119.286C54.1132 119.203 53.9368 119.243 53.8528 119.375Z"
      fill="url(#paint34_linear_5708_65144)"
    />
    <path
      d="M53.168 120.458C53.0839 120.59 53.124 120.766 53.2575 120.849L55.0704 121.985C55.2039 122.069 55.3803 122.029 55.4643 121.896C55.5484 121.763 55.5083 121.588 55.3748 121.504L53.5618 120.368C53.4284 120.285 53.252 120.325 53.168 120.458Z"
      fill="url(#paint35_linear_5708_65144)"
    />
    <path
      d="M52.166 122.041C52.089 122.163 52.1258 122.324 52.2481 122.401L55.7934 124.621C55.9158 124.698 56.0774 124.661 56.1545 124.539L56.1798 124.499C56.2569 124.378 56.2201 124.217 56.0977 124.14L52.5524 121.919C52.43 121.843 52.2684 121.879 52.1913 122.001L52.166 122.041Z"
      fill="url(#paint36_linear_5708_65144)"
    />
    <path
      d="M51.4941 123.104C51.4101 123.236 51.4502 123.412 51.5837 123.495L53.3966 124.631C53.5301 124.715 53.7065 124.675 53.7905 124.542C53.8745 124.409 53.8345 124.234 53.701 124.15L51.888 123.014C51.7545 122.931 51.5781 122.971 51.4941 123.104Z"
      fill="url(#paint37_linear_5708_65144)"
    />
    <path
      d="M50.8096 124.186C50.7255 124.319 50.7656 124.494 50.8992 124.578L52.7121 125.713C52.8456 125.797 53.0219 125.757 53.106 125.624C53.19 125.492 53.15 125.316 53.0164 125.232L51.2035 124.097C51.07 124.013 50.8936 124.053 50.8096 124.186Z"
      fill="url(#paint38_linear_5708_65144)"
    />
    <path
      d="M50.1243 125.269C50.0402 125.401 50.0803 125.577 50.2138 125.66L52.0267 126.796C52.1602 126.88 52.3366 126.84 52.4206 126.707C52.5047 126.574 52.4646 126.399 52.3311 126.315L50.5182 125.179C50.3847 125.096 50.2083 125.136 50.1243 125.269Z"
      fill="url(#paint39_linear_5708_65144)"
    />
    <path
      d="M49.4394 126.351C49.3554 126.483 49.3955 126.659 49.529 126.742L51.3419 127.878C51.4754 127.962 51.6518 127.922 51.7358 127.789C51.8199 127.656 51.7798 127.481 51.6463 127.397L49.8333 126.261C49.6998 126.178 49.5235 126.218 49.4394 126.351Z"
      fill="url(#paint40_linear_5708_65144)"
    />
    <path
      d="M48.4377 127.934C48.3607 128.056 48.3975 128.217 48.5199 128.293L52.0651 130.514C52.1875 130.591 52.3492 130.554 52.4262 130.432L52.4515 130.392C52.5286 130.271 52.4918 130.11 52.3694 130.033L48.8241 127.813C48.7018 127.736 48.5401 127.772 48.4631 127.894L48.4377 127.934Z"
      fill="url(#paint41_linear_5708_65144)"
    />
    <path
      d="M47.7651 128.997C47.6811 129.129 47.7212 129.305 47.8547 129.389L49.6676 130.524C49.8011 130.608 49.9775 130.568 50.0615 130.435C50.1455 130.302 50.1055 130.127 49.972 130.043L48.159 128.908C48.0255 128.824 47.8491 128.864 47.7651 128.997Z"
      fill="url(#paint42_linear_5708_65144)"
    />
    <path
      d="M47.0806 130.079C46.9965 130.211 47.0366 130.387 47.1701 130.471L48.983 131.606C49.1166 131.69 49.2929 131.65 49.3769 131.517C49.461 131.384 49.4209 131.209 49.2874 131.125L47.4744 129.99C47.341 129.906 47.1646 129.946 47.0806 130.079Z"
      fill="url(#paint43_linear_5708_65144)"
    />
    <path
      d="M46.3957 131.161C46.3117 131.294 46.3518 131.469 46.4853 131.553L48.2982 132.689C48.4317 132.772 48.6081 132.732 48.6921 132.6C48.7761 132.467 48.7361 132.291 48.6026 132.208L46.7896 131.072C46.6561 130.988 46.4798 131.028 46.3957 131.161Z"
      fill="url(#paint44_linear_5708_65144)"
    />
    <path
      d="M45.711 132.243C45.6269 132.376 45.667 132.552 45.8005 132.635L47.6134 133.771C47.7469 133.854 47.9233 133.814 48.0073 133.682C48.0914 133.549 48.0513 133.373 47.9178 133.29L46.1048 132.154C45.9713 132.07 45.795 132.11 45.711 132.243Z"
      fill="url(#paint45_linear_5708_65144)"
    />
    <path
      d="M44.7095 133.826C44.6324 133.948 44.6692 134.109 44.7916 134.186L48.3369 136.406C48.4593 136.483 48.621 136.446 48.6979 136.325L48.7233 136.285C48.8003 136.163 48.7635 136.002 48.6412 135.925L45.0959 133.705C44.9735 133.628 44.8118 133.665 44.7348 133.786L44.7095 133.826Z"
      fill="url(#paint46_linear_5708_65144)"
    />
    <path
      d="M44.0376 134.888C43.9536 135.021 43.9936 135.197 44.1271 135.28L45.9401 136.416C46.0736 136.499 46.25 136.459 46.334 136.327C46.418 136.194 46.3779 136.018 46.2444 135.935L44.4315 134.799C44.298 134.715 44.1216 134.755 44.0376 134.888Z"
      fill="url(#paint47_linear_5708_65144)"
    />
    <path
      d="M43.3528 135.971C43.2687 136.104 43.3089 136.279 43.4423 136.363L45.2553 137.498C45.3888 137.582 45.5652 137.542 45.6492 137.409C45.7332 137.276 45.6931 137.101 45.5596 137.017L43.7467 135.882C43.6131 135.798 43.4368 135.838 43.3528 135.971Z"
      fill="url(#paint48_linear_5708_65144)"
    />
    <path
      d="M42.6687 137.053C42.5847 137.186 42.6247 137.362 42.7582 137.445L44.5712 138.581C44.7047 138.664 44.8811 138.624 44.9651 138.492C45.0491 138.359 45.009 138.183 44.8755 138.1L43.0626 136.964C42.929 136.881 42.7527 136.92 42.6687 137.053Z"
      fill="url(#paint49_linear_5708_65144)"
    />
    <path
      d="M41.9839 138.136C41.8998 138.269 41.94 138.444 42.0734 138.528L43.8864 139.663C44.0199 139.747 44.1963 139.707 44.2803 139.574C44.3643 139.441 44.3242 139.266 44.1907 139.182L42.3778 138.047C42.2442 137.963 42.0679 138.003 41.9839 138.136Z"
      fill="url(#paint50_linear_5708_65144)"
    />
    <path
      d="M40.9814 139.719C40.9044 139.841 40.9412 140.002 41.0636 140.078L44.6089 142.299C44.7312 142.375 44.8929 142.339 44.9699 142.217L44.9952 142.177C45.0723 142.055 45.0355 141.894 44.9131 141.818L41.3678 139.597C41.2455 139.521 41.0838 139.557 41.0068 139.679L40.9814 139.719Z"
      fill="url(#paint51_linear_5708_65144)"
    />
    <path
      d="M40.3096 140.781C40.2255 140.914 40.2656 141.09 40.3991 141.173L42.212 142.309C42.3455 142.392 42.5219 142.352 42.6059 142.22C42.69 142.087 42.6499 141.911 42.5164 141.828L40.7035 140.692C40.57 140.609 40.3936 140.648 40.3096 140.781Z"
      fill="url(#paint52_linear_5708_65144)"
    />
    <path
      d="M39.6247 141.864C39.5407 141.997 39.5808 142.172 39.7143 142.256L41.5272 143.391C41.6607 143.475 41.837 143.435 41.9211 143.302C42.0051 143.169 41.9651 142.994 41.8316 142.91L40.0186 141.775C39.8851 141.691 39.7088 141.731 39.6247 141.864Z"
      fill="url(#paint53_linear_5708_65144)"
    />
    <path
      d="M38.9402 142.946C38.8562 143.079 38.8962 143.254 39.0298 143.338L40.8427 144.473C40.9762 144.557 41.1526 144.517 41.2366 144.384C41.3207 144.251 41.2806 144.076 41.1471 143.992L39.3341 142.857C39.2006 142.773 39.0243 142.813 38.9402 142.946Z"
      fill="url(#paint54_linear_5708_65144)"
    />
    <path
      d="M38.2549 144.028C38.1709 144.161 38.2109 144.337 38.3444 144.42L40.1574 145.556C40.2909 145.639 40.4672 145.6 40.5513 145.467C40.6353 145.334 40.5952 145.158 40.4617 145.075L38.6488 143.939C38.5153 143.856 38.339 143.895 38.2549 144.028Z"
      fill="url(#paint55_linear_5708_65144)"
    />
    <path
      d="M37.2539 145.612C37.1769 145.733 37.2136 145.894 37.336 145.971L40.8813 148.191C41.0037 148.268 41.1653 148.232 41.2424 148.11L41.2677 148.07C41.3447 147.948 41.308 147.787 41.1856 147.71L37.6403 145.49C37.5179 145.413 37.3563 145.45 37.2792 145.571L37.2539 145.612Z"
      fill="url(#paint56_linear_5708_65144)"
    />
    <path
      d="M36.5813 146.674C36.4973 146.807 36.5373 146.983 36.6708 147.066L38.4838 148.202C38.6173 148.285 38.7937 148.245 38.8777 148.113C38.9618 147.98 38.9216 147.804 38.7881 147.721L36.9752 146.585C36.8417 146.502 36.6653 146.541 36.5813 146.674Z"
      fill="url(#paint57_linear_5708_65144)"
    />
    <path
      d="M35.8962 147.756C35.8122 147.889 35.8523 148.064 35.9858 148.148L37.7987 149.283C37.9322 149.367 38.1085 149.327 38.1926 149.194C38.2766 149.061 38.2366 148.886 38.1031 148.802L36.2901 147.667C36.1566 147.583 35.9802 147.623 35.8962 147.756Z"
      fill="url(#paint58_linear_5708_65144)"
    />
    <path
      d="M35.2114 148.838C35.1274 148.971 35.1675 149.147 35.301 149.23L37.1139 150.366C37.2474 150.45 37.4238 150.41 37.5078 150.277C37.5918 150.144 37.5517 149.968 37.4183 149.885L35.6053 148.749C35.4718 148.666 35.2954 148.706 35.2114 148.838Z"
      fill="url(#paint59_linear_5708_65144)"
    />
    <path
      d="M55.521 144.601L54.5826 165.007C54.5539 165.629 55.0132 166.176 55.6654 166.297L64.6637 167.954C66.2463 168.245 67.5957 166.844 67.1214 165.401L62.863 152.45C62.593 151.629 62.6664 150.741 63.0685 149.965C63.9081 147.474 65.1224 145.238 66.5874 143.171L55.521 144.601Z"
      fill="url(#paint60_linear_5708_65144)"
    />
    <path
      d="M64.8904 146.219C64.6365 146.011 64.2544 146.094 64.1099 146.388L62.9589 148.727C62.8413 148.966 62.9298 149.255 63.1614 149.389L63.3288 149.485C63.5971 149.639 63.9406 149.521 64.0562 149.235L65.0398 146.799C65.1227 146.594 65.0622 146.359 64.8904 146.219Z"
      fill="url(#paint61_linear_5708_65144)"
    />
    <path
      d="M91.0604 136.281L97.401 135.978C97.4385 135.976 97.4675 135.944 97.4657 135.907L97.4507 135.595C97.4489 135.558 97.417 135.529 97.3794 135.531L91.0389 135.834C91.0014 135.835 90.9724 135.867 90.9742 135.904L90.9893 136.216C90.991 136.254 91.0229 136.282 91.0604 136.281Z"
      fill="url(#paint62_linear_5708_65144)"
    />
    <path
      d="M90.682 134.161L92.7153 135.361C92.8643 135.448 92.9589 135.605 92.9672 135.777L92.9883 136.216C92.9944 136.342 92.9472 136.464 92.8582 136.554L90.925 138.505C90.8265 138.604 90.6941 138.663 90.554 138.67L86.8259 138.848L86.6052 134.272L90.3994 134.091C90.4985 134.086 90.5967 134.11 90.682 134.161Z"
      fill="url(#paint63_linear_5708_65144)"
    />
    <path
      d="M82.2326 139.038L86.1786 138.849L85.9579 134.274L82.012 134.462L82.2326 139.038Z"
      fill="url(#paint64_linear_5708_65144)"
    />
    <path
      d="M80.0339 139.667L83.5974 139.497C84.086 139.473 84.4631 139.06 84.4397 138.574L84.2487 134.613C84.2264 134.15 83.8311 133.793 83.3656 133.815L79.76 133.987L80.0339 139.667Z"
      fill="url(#paint65_linear_5708_65144)"
    />
    <path
      d="M77.2474 141.539L80.3719 141.39C81.1029 141.355 81.6672 140.737 81.6321 140.01L81.3352 133.852C81.3017 133.16 80.7103 132.625 80.0141 132.658L76.8264 132.81L77.2474 141.539Z"
      fill="url(#paint66_linear_5708_65144)"
    />
    <path
      d="M52.5329 144.984L78.2853 142.177L77.8289 132.713L51.9456 132.805C44.1624 133.947 45.2631 144.841 52.5329 144.984Z"
      fill="url(#paint67_linear_5708_65144)"
    />
    <path
      d="M86.1256 139.568L89.0276 139.43C89.3753 139.413 89.6437 139.119 89.627 138.773L89.4012 134.091C89.3845 133.745 89.0891 133.478 88.7414 133.494L85.8394 133.633C85.4917 133.649 85.2233 133.943 85.24 134.289L85.4658 138.972C85.4825 139.318 85.7779 139.585 86.1256 139.568Z"
      fill="url(#paint68_linear_5708_65144)"
    />
    <path
      d="M22.9304 140.53L24.2846 140.387L22.6306 126.225L21.5615 126.338L22.9304 140.53Z"
      fill="url(#paint69_linear_5708_65144)"
    />
    <path
      d="M22.2119 137.055L24.254 136.84C24.635 136.8 24.9793 137.068 25.0321 137.445L26.7407 149.669C26.8697 150.592 26.2052 151.438 25.2738 151.536L24.3133 151.637C23.382 151.736 22.5539 151.047 22.4854 150.118L21.5786 137.81C21.5506 137.429 21.8309 137.096 22.2119 137.055Z"
      fill="url(#paint70_linear_5708_65144)"
    />
    <path
      d="M25.3294 150.45L25.8457 150.396L24.4815 137.602L23.9652 137.657L25.3294 150.45Z"
      fill="#7D97F4"
    />
    <path
      d="M24.3865 150.552L24.9028 150.497L23.5386 137.703L23.0223 137.758L24.3865 150.552Z"
      fill="#7D97F4"
    />
    <path
      d="M23.451 150.649L23.9673 150.595L22.6031 137.801L22.0867 137.855L23.451 150.649Z"
      fill="#7D97F4"
    />
    <path
      d="M21.2602 121.63L21.9335 121.559C22.1112 121.54 22.2754 121.627 22.3273 121.766L23.0253 123.638C23.0389 123.674 23.044 123.713 23.0404 123.752L22.8003 126.302C22.786 126.454 22.6409 126.579 22.4573 126.599L21.7461 126.674C21.5596 126.694 21.3893 126.598 21.3463 126.449L20.638 124.002C20.6278 123.967 20.6253 123.93 20.6307 123.894L20.9188 121.914C20.9401 121.767 21.0825 121.649 21.2602 121.63Z"
      fill="url(#paint71_linear_5708_65144)"
    />
    <path
      d="M5.88146 178.708H74.6195C75.7613 178.708 76.687 177.787 76.687 176.651V149.386C76.687 148.25 75.7613 147.329 74.6195 147.329H5.88146C4.73965 147.329 3.81396 148.25 3.81396 149.386V176.651C3.81396 177.787 4.73965 178.708 5.88146 178.708Z"
      fill="url(#paint72_linear_5708_65144)"
    />
    <path
      d="M0.407213 176.737H79.3093C79.4961 176.737 79.6476 176.586 79.6476 176.4V168.768C79.6476 168.582 79.4961 168.432 79.3093 168.432H0.407213C0.220366 168.432 0.0688477 168.582 0.0688477 168.768V176.4C0.0688477 176.586 0.2203 176.737 0.407213 176.737Z"
      fill="url(#paint73_linear_5708_65144)"
    />
    <path
      d="M1.07585 167.191H78.6406C79.1968 167.191 79.6476 166.742 79.6476 166.189V159.03C79.6476 158.476 79.1968 158.028 78.6406 158.028H1.07585C0.519716 158.028 0.0688477 158.476 0.0688477 159.03V166.189C0.0688477 166.742 0.519716 167.191 1.07585 167.191Z"
      fill="url(#paint74_linear_5708_65144)"
    />
    <path
      d="M0.878477 156.661H78.838C79.2852 156.661 79.6476 156.3 79.6476 155.855V148.135C79.6476 147.69 79.2851 147.329 78.838 147.329H0.878477C0.431292 147.329 0.0688477 147.69 0.0688477 148.135V155.855C0.0688477 156.3 0.431292 156.661 0.878477 156.661Z"
      fill="url(#paint75_linear_5708_65144)"
    />
    <path
      d="M130.667 178.192C130.955 178.192 131.188 177.96 131.188 177.674V115.704C131.188 115.418 130.955 115.186 130.667 115.186C130.379 115.186 130.146 115.418 130.146 115.704V177.674C130.146 177.96 130.379 178.192 130.667 178.192Z"
      fill="url(#paint76_linear_5708_65144)"
    />
    <path
      d="M144.787 178.192C145.075 178.192 145.309 177.96 145.309 177.674V115.704C145.309 115.418 145.075 115.186 144.787 115.186C144.499 115.186 144.266 115.418 144.266 115.704V177.674C144.266 177.96 144.499 178.192 144.787 178.192Z"
      fill="url(#paint77_linear_5708_65144)"
    />
    <path
      d="M179.479 178.586C179.547 178.586 179.616 178.572 179.683 178.544C179.947 178.432 180.071 178.128 179.958 177.864L153.313 115.502C153.2 115.238 152.894 115.116 152.629 115.227C152.365 115.339 152.241 115.644 152.354 115.907L178.999 178.27C179.083 178.467 179.276 178.586 179.479 178.586Z"
      fill="url(#paint78_linear_5708_65144)"
    />
    <path
      d="M163.02 178.586C163.088 178.586 163.157 178.572 163.224 178.544C163.489 178.432 163.612 178.128 163.5 177.864L136.854 115.502C136.741 115.238 136.435 115.116 136.171 115.227C135.906 115.339 135.782 115.644 135.895 115.907L162.541 178.27C162.625 178.467 162.818 178.586 163.02 178.586Z"
      fill="url(#paint79_linear_5708_65144)"
    />
    <path
      d="M129.308 116.275H168.107C168.209 116.275 168.292 116.193 168.292 116.091V114.078C168.292 113.976 168.209 113.894 168.107 113.894H129.308C129.206 113.894 129.123 113.976 129.123 114.078V116.091C129.123 116.193 129.206 116.275 129.308 116.275Z"
      fill="url(#paint80_linear_5708_65144)"
    />
    <path
      d="M140.4 125.759H156.907C157.195 125.759 157.429 125.527 157.429 125.24C157.429 124.954 157.195 124.722 156.907 124.722H140.4C140.112 124.722 139.879 124.954 139.879 125.24C139.879 125.527 140.112 125.759 140.4 125.759Z"
      fill="url(#paint81_linear_5708_65144)"
    />
    <path
      d="M161.972 136.516H145.465V137.553H161.972V136.516Z"
      fill="url(#paint82_linear_5708_65144)"
    />
    <path
      d="M166.876 148.311H150.369V149.347H166.876V148.311Z"
      fill="url(#paint83_linear_5708_65144)"
    />
    <path
      d="M155.511 161.141H172.018C172.306 161.141 172.539 160.909 172.539 160.623C172.539 160.337 172.306 160.104 172.018 160.104H155.511C155.223 160.104 154.99 160.337 154.99 160.623C154.99 160.909 155.223 161.141 155.511 161.141Z"
      fill="url(#paint84_linear_5708_65144)"
    />
    <path
      d="M160.483 172.936H176.99C177.278 172.936 177.511 172.704 177.511 172.418C177.511 172.131 177.278 171.899 176.99 171.899H160.483C160.195 171.899 159.961 172.131 159.961 172.418C159.961 172.704 160.195 172.936 160.483 172.936Z"
      fill="url(#paint85_linear_5708_65144)"
    />
    <path
      d="M107.24 178.42C100.997 180.495 94.9302 180.497 89.0808 178.601C87.6021 178.121 86.6006 176.75 86.6006 175.203V146.696C93.7889 148.27 101.324 148.35 109.261 146.696V175.644C109.261 176.906 108.444 178.02 107.24 178.42Z"
      fill="url(#paint86_linear_5708_65144)"
    />
    <path
      d="M97.9311 148.734C104.189 148.734 109.261 147.72 109.261 146.468C109.261 145.217 104.189 144.203 97.9311 144.203C91.6736 144.203 86.6008 145.217 86.6008 146.468C86.6008 147.72 91.6736 148.734 97.9311 148.734Z"
      fill="url(#paint87_linear_5708_65144)"
    />
    <path
      d="M109.261 168.645C101.708 171.26 94.154 171.26 86.6006 168.645V157.273C94.2221 159.143 101.779 159.238 109.261 157.273V168.645Z"
      fill="url(#paint88_linear_5708_65144)"
    />
    <path
      d="M87.8159 149.287C88.0588 150.19 89.0936 150.798 90.0055 150.575C90.6448 150.418 91.1912 149.92 91.8494 149.909C92.5969 149.896 93.1938 150.51 93.6297 151.114C94.4216 152.212 95.0239 153.445 95.4023 154.743C95.5283 155.175 95.64 155.634 95.9451 155.966C96.5981 156.678 97.8329 156.45 98.5586 155.812C99.2843 155.175 99.6787 154.254 100.218 153.454C100.757 152.654 101.585 151.908 102.552 151.966C102.875 151.986 103.189 152.096 103.513 152.109C104.23 152.139 104.935 151.634 105.133 150.948C105.194 150.737 105.213 150.511 105.322 150.32C105.649 149.751 106.515 149.695 106.963 149.233C107.247 148.941 107.342 148.514 107.673 148.226C107.798 148.117 108.658 147.764 108.675 147.71C108.827 147.25 108.346 146.835 107.902 146.639C105.297 145.484 102.32 146.635 99.4951 147.028C96.7209 147.415 94.0658 146.785 91.3177 146.809C89.8028 146.822 87.2505 147.185 87.8159 149.287Z"
      fill="url(#paint89_linear_5708_65144)"
    />
    <path
      d="M98.0622 148.798C104.32 148.798 109.392 147.784 109.392 146.533C109.392 145.281 104.32 144.267 98.0622 144.267C91.8047 144.267 86.7319 145.281 86.7319 146.533C86.7319 147.784 91.8047 148.798 98.0622 148.798Z"
      fill="#7D97F4"
    />
    <path
      d="M97.7603 147.903C102.912 147.903 107.087 147.29 107.087 146.533C107.087 145.776 102.912 145.163 97.7603 145.163C92.609 145.163 88.4331 145.776 88.4331 146.533C88.4331 147.29 92.609 147.903 97.7603 147.903Z"
      fill="url(#paint90_linear_5708_65144)"
    />
    <path
      d="M162.309 64.8628C163.16 65.7658 164.412 66.5461 165.293 67.0327C163.977 68.6508 162.197 70.2712 159.84 71.8572L159.166 73.3632L157.004 70.786C157.004 70.786 160.882 68.8659 162.309 64.8628Z"
      fill="url(#paint91_linear_5708_65144)"
    />
    <path
      d="M156.837 88.4401C157.681 89.4323 159.181 89.5376 160.156 88.6731L162.97 86.1804C163.945 85.3159 164.013 83.8213 163.12 82.8727L119.548 36.9624L116.031 40.079L156.837 88.4401ZM152.932 80.8241C150.594 78.2117 149.378 75.492 150.216 74.7494C151.054 74.0068 153.629 75.5226 155.967 78.1351C158.306 80.7475 159.522 83.4672 158.684 84.2098C157.846 84.9524 155.271 83.4365 152.932 80.8241Z"
      fill="url(#paint92_linear_5708_65144)"
    />
    <path
      d="M116.031 40.079L119.548 36.9624L132.512 50.7302L128.28 54.4805L116.031 40.079Z"
      fill="url(#paint93_linear_5708_65144)"
    />
    <path
      d="M105 51.1689L131.892 27.3405C132.175 27.089 132.201 26.656 131.948 26.3735L129.616 23.7681L101.696 48.5075L104.028 51.1129C104.281 51.3954 104.716 51.4205 105 51.1689Z"
      fill="url(#paint94_linear_5708_65144)"
    />
    <path
      d="M101.696 48.5072L129.616 23.7678C122.498 16.0775 116.501 8.22085 112.957 0L107.899 4.48178L107.173 10.3586L102.942 8.87395L96.4234 14.6502L95.3983 19.7997L92.4218 18.1961L84.582 25.1428C86.2181 32.7993 93.5328 40.6395 101.696 48.5072Z"
      fill="url(#paint95_linear_5708_65144)"
    />
    <path
      opacity="0.7"
      d="M103.044 44.8925C93.734 36.1707 88.2604 26.5091 88.2063 26.4125L88.3961 26.3071C88.4503 26.4034 93.9085 36.0371 103.193 44.735L103.044 44.8925Z"
      fill="white"
    />
    <path
      opacity="0.7"
      d="M104.602 43.5165C96.6466 36.5354 90.0923 24.9151 90.0271 24.7986L90.2169 24.6934C90.2821 24.8096 96.8187 36.3981 104.745 43.3543L104.602 43.5165Z"
      fill="white"
    />
    <path
      opacity="0.7"
      d="M112.859 36.2116C103.794 29.4867 98.6266 17.3302 98.5754 17.2082L98.7763 17.125C98.827 17.2465 103.972 29.3493 112.989 36.0382L112.859 36.2116Z"
      fill="white"
    />
    <path
      opacity="0.7"
      d="M115.028 34.2898C106.364 27.9243 100.748 15.4604 100.693 15.3352L100.891 15.2476C100.947 15.3722 106.54 27.7848 115.158 34.1158L115.028 34.2898Z"
      fill="white"
    />
    <path
      opacity="0.7"
      d="M123.495 26.7605C114.556 17.2748 110.939 7.27841 110.904 7.17845L111.109 7.10645C111.144 7.20582 114.747 17.1615 123.654 26.6126L123.495 26.7605Z"
      fill="white"
    />
    <path
      d="M150.743 113.742C150.743 113.696 150.746 113.649 150.757 113.602C151.457 110.841 154.932 109.121 154.932 109.121L156.308 109.228C157.1 111.662 156.998 113.155 156.871 113.82C156.868 113.838 156.862 113.856 156.857 113.874C155.721 113.975 153.384 114.041 150.743 113.742Z"
      fill="url(#paint96_linear_5708_65144)"
    />
    <path
      d="M156.857 113.874C156.796 114.096 156.631 114.269 156.42 114.313C154.805 114.651 152.237 114.379 151.159 114.239C150.921 114.208 150.748 113.989 150.744 113.742C153.384 114.041 155.722 113.975 156.857 113.874Z"
      fill="url(#paint97_linear_5708_65144)"
    />
    <path
      d="M156.863 107.189L156.28 109.981C156.237 110.186 156.079 110.339 155.887 110.357C155.653 110.379 155.319 110.392 154.984 110.343C154.683 110.299 154.474 109.995 154.527 109.668L154.932 107.188L156.863 107.189Z"
      fill="url(#paint98_linear_5708_65144)"
    />
    <path
      d="M144.781 113.846C146.301 113.804 147.088 113.626 147.494 113.46C147.495 113.611 147.495 113.764 147.49 113.923C147.484 114.092 147.358 114.227 147.203 114.226L138.855 114.173C138.588 114.171 138.433 113.863 138.548 113.62C139.643 113.71 142.431 113.912 144.781 113.846Z"
      fill="url(#paint99_linear_5708_65144)"
    />
    <path
      d="M138.548 113.621C138.558 113.6 138.567 113.578 138.581 113.558C139.319 112.533 141.196 110.492 144.907 109.607L146.687 109.551C146.687 109.551 147.48 110.922 147.495 113.461C147.088 113.626 146.302 113.804 144.781 113.846C142.431 113.912 139.643 113.711 138.548 113.621Z"
      fill="url(#paint100_linear_5708_65144)"
    />
    <path
      d="M147.017 106.866C146.997 106.999 146.753 109.005 146.659 109.783C146.636 109.968 146.502 110.111 146.332 110.131C146.029 110.167 145.539 110.2 145.109 110.112C144.878 110.065 144.71 109.844 144.71 109.587V106.437L147.017 106.866Z"
      fill="url(#paint101_linear_5708_65144)"
    />
    <path
      d="M148.445 70.2491C148.445 70.2491 144.152 86.4835 144.23 106.913C144.231 107.285 144.494 107.607 144.86 107.684C145.4 107.797 146.194 107.931 146.85 107.913C147.201 107.903 147.494 107.644 147.553 107.3C148.155 103.787 151.61 83.9992 153.578 80.7866C153.578 80.7866 154.873 98.4108 154.459 107.554C154.449 107.782 154.616 107.979 154.844 108.005C155.188 108.045 155.74 108.075 156.441 108.001C156.708 107.973 156.923 107.772 156.961 107.508C157.39 104.536 159.858 86.8404 159.753 74.0934C159.747 73.3745 157.842 70.249 157.842 70.249L148.445 70.2491Z"
      fill="url(#paint102_linear_5708_65144)"
    />
    <path
      d="M142.474 50.6015C143.171 49.7324 143.782 48.8009 144.292 47.841C145.005 46.5005 145.556 45.0329 145.751 43.519C150.574 44.3533 157.927 45.3013 161.037 45.6913C162.057 45.8191 162.99 46.3194 163.662 47.0934C166.328 50.1625 172.177 58.5655 165.292 67.0326C164.411 66.546 163.159 65.7658 162.309 64.8627C163.071 62.7264 163.133 59.9963 161.537 56.6485C161.482 56.9139 161.415 57.1766 161.333 57.4351C159.133 64.3702 159.016 70.1412 159.02 71.4713C159.021 71.6519 158.912 71.8145 158.744 71.8817C155.848 73.0362 150.274 72.3491 148.403 72.0717C148.06 72.0208 147.829 71.7031 147.877 71.3612C148.795 64.7417 144.082 53.8526 142.837 51.1251C142.748 50.929 142.624 50.7523 142.474 50.6015Z"
      fill="url(#paint103_linear_5708_65144)"
    />
    <path
      d="M156.033 39.323L156.591 44.996C156.591 44.996 153.383 45.9571 151.05 44.3194L152.69 39.1636L156.033 39.323Z"
      fill="url(#paint104_linear_5708_65144)"
    />
    <path
      d="M161.829 56.1301C162.997 52.9523 162.573 49.115 162.569 49.0767L162.247 49.1132C162.251 49.1509 162.666 52.9146 161.525 56.0195L161.829 56.1301Z"
      fill="url(#paint105_linear_5708_65144)"
    />
    <path
      d="M153.736 80.373C153.808 80.373 153.874 80.3249 153.893 80.2524C154.249 78.8861 156.915 77.3846 156.942 77.3695C157.019 77.326 157.047 77.2279 157.004 77.1502C156.96 77.0726 156.862 77.0449 156.783 77.0886C156.668 77.1525 153.97 78.6725 153.579 80.1714C153.557 80.2576 153.609 80.3455 153.695 80.3678C153.709 80.3714 153.723 80.373 153.736 80.373Z"
      fill="url(#paint106_linear_5708_65144)"
    />
    <path
      d="M129.697 50.8692C135.738 51.771 139.134 47.4539 142.068 45.1535C145.941 42.1165 149.885 44.1622 149.885 44.1622L145.365 51.9626C139.196 57.7492 132.872 56.4641 128.885 54.589C128.823 53.074 129.23 51.8061 129.697 50.8692Z"
      fill="url(#paint107_linear_5708_65144)"
    />
    <path
      d="M121.328 45.8232L123.211 48.3559C125.613 49.8112 127.763 50.5801 129.697 50.8689C129.23 51.8059 128.823 53.0738 128.885 54.5887C126.347 53.395 124.755 51.9623 124.755 51.9623C120.218 49.2702 121.328 45.8232 121.328 45.8232Z"
      fill="url(#paint108_linear_5708_65144)"
    />
    <path
      d="M151.47 34.2959C151.47 34.2959 149.045 38.8386 149.356 40.6737C149.667 42.5088 152.673 42.377 155.297 40.8866L157.132 35.9815L151.47 34.2959Z"
      fill="url(#paint109_linear_5708_65144)"
    />
    <path
      d="M155.181 38.4775C155.074 38.4305 155.035 38.3006 155.099 38.2035C155.293 37.9082 155.658 37.3055 155.774 36.778C155.774 36.778 156.21 36.5002 154.664 36.132C153.118 35.7639 150.813 35.1925 150.329 33.8833C149.856 32.6069 152.39 30.9501 154.37 33.5077C154.445 33.605 153.301 32.0541 153.376 31.9567C153.7 31.5363 154.554 30.6637 155.739 31.1927C156.848 31.6877 156.973 32.4962 156.957 32.9037C156.953 33.0236 157.061 33.1168 157.179 33.0943C157.74 32.9879 159.085 32.8965 159.713 34.2697C160.23 35.4007 159.894 36.041 159.588 36.3542C159.488 36.4556 159.532 36.6227 159.668 36.6641C160.036 36.7763 159.913 36.5974 159.865 37.4563C159.799 38.6437 159.064 39.0289 158.685 38.9748C158.622 38.9659 158.56 38.9872 158.517 39.0336C158.192 39.3922 156.724 40.915 155.136 41.0987C154.998 41.1145 154.892 40.9794 154.937 40.8491L155.624 38.861C155.656 38.7686 155.612 38.6674 155.522 38.6278L155.181 38.4775Z"
      fill="url(#paint110_linear_5708_65144)"
    />
    <path
      d="M154.905 38.7596C154.905 38.7596 156.632 37.5807 156.758 38.5734C156.884 39.5662 155.203 40.0115 154.37 39.6414L154.905 38.7596Z"
      fill="url(#paint111_linear_5708_65144)"
    />
    <path
      d="M149.328 32.5468L159.573 40.181L159.398 39.4885C159.398 39.4885 163.571 35.1088 159.457 31.6226C155.342 28.1365 150.644 32.2615 150.644 32.2615L149.328 32.5468Z"
      fill="url(#paint112_linear_5708_65144)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5708_65144"
        x1="27.7749"
        y1="47.5091"
        x2="38.3705"
        y2="47.5091"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5708_65144"
        x1="19.9847"
        y1="47.6026"
        x2="46.0418"
        y2="47.6026"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5708_65144"
        x1="60.7754"
        y1="20.8406"
        x2="67.9949"
        y2="20.8406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5708_65144"
        x1="55.3592"
        y1="20.9058"
        x2="73.3363"
        y2="20.9058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5708_65144"
        x1="50.4521"
        y1="101.476"
        x2="-12.038"
        y2="69.0196"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5708_65144"
        x1="24.3935"
        y1="3.05676"
        x2="26.5459"
        y2="39.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5708_65144"
        x1="116.62"
        y1="113.176"
        x2="153.29"
        y2="113.176"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_5708_65144"
        x1="57.9639"
        y1="112.476"
        x2="94.6339"
        y2="112.476"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DAE3FE" />
        <stop offset="1" stop-color="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_5708_65144"
        x1="88.6134"
        y1="36.6601"
        x2="66.1735"
        y2="76.1281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_5708_65144"
        x1="101.168"
        y1="-15.9837"
        x2="106.732"
        y2="105.056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_5708_65144"
        x1="69.7938"
        y1="12.2638"
        x2="87.1807"
        y2="48.1567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1473D" />
        <stop offset="1" stop-color="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_5708_65144"
        x1="37.8824"
        y1="75.6955"
        x2="39.4966"
        y2="103.925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_5708_65144"
        x1="61.4565"
        y1="128.656"
        x2="104.754"
        y2="158.558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_5708_65144"
        x1="9.21223"
        y1="120.062"
        x2="8.25517"
        y2="178.975"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_5708_65144"
        x1="49.437"
        y1="92.1204"
        x2="31.46"
        y2="156.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_5708_65144"
        x1="31.906"
        y1="141.705"
        x2="28.4872"
        y2="171.016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_5708_65144"
        x1="9.73593"
        y1="127.968"
        x2="12.1309"
        y2="131.193"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_5708_65144"
        x1="4.07296"
        y1="130.036"
        x2="38.3791"
        y2="176.224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_5708_65144"
        x1="-9.25785"
        y1="133.361"
        x2="15.6926"
        y2="131.233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_5708_65144"
        x1="101.359"
        y1="32.5341"
        x2="85.1851"
        y2="65.046"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_5708_65144"
        x1="57.693"
        y1="125.2"
        x2="16.7519"
        y2="155.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="0.2063" stop-color="#FEB3B1" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_5708_65144"
        x1="67.3518"
        y1="106.842"
        x2="63.3747"
        y2="104.326"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_5708_65144"
        x1="64.0058"
        y1="105.799"
        x2="63.4295"
        y2="106.922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_5708_65144"
        x1="63.3213"
        y1="106.882"
        x2="62.7449"
        y2="108.005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_5708_65144"
        x1="62.6365"
        y1="107.964"
        x2="62.0601"
        y2="109.087"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_5708_65144"
        x1="61.9516"
        y1="109.047"
        x2="61.3753"
        y2="110.169"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_5708_65144"
        x1="63.6232"
        y1="112.735"
        x2="59.6462"
        y2="110.219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_5708_65144"
        x1="60.2778"
        y1="111.692"
        x2="59.7015"
        y2="112.815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_5708_65144"
        x1="59.593"
        y1="112.774"
        x2="59.0166"
        y2="113.897"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_5708_65144"
        x1="58.9082"
        y1="113.857"
        x2="58.3318"
        y2="114.979"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_5708_65144"
        x1="58.2236"
        y1="114.939"
        x2="57.6473"
        y2="116.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_5708_65144"
        x1="59.8957"
        y1="118.627"
        x2="55.9186"
        y2="116.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_5708_65144"
        x1="56.5498"
        y1="117.584"
        x2="55.9734"
        y2="118.707"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_5708_65144"
        x1="55.865"
        y1="118.666"
        x2="55.2887"
        y2="119.789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_5708_65144"
        x1="55.1804"
        y1="119.749"
        x2="54.6041"
        y2="120.871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_5708_65144"
        x1="54.4956"
        y1="120.831"
        x2="53.9192"
        y2="121.953"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_5708_65144"
        x1="56.1672"
        y1="124.519"
        x2="52.1901"
        y2="122.003"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_5708_65144"
        x1="52.8218"
        y1="123.477"
        x2="52.2454"
        y2="124.599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_5708_65144"
        x1="52.1372"
        y1="124.559"
        x2="51.5608"
        y2="125.682"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_5708_65144"
        x1="51.4519"
        y1="125.642"
        x2="50.8755"
        y2="126.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_5708_65144"
        x1="50.767"
        y1="126.724"
        x2="50.1907"
        y2="127.846"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_5708_65144"
        x1="52.4389"
        y1="130.412"
        x2="48.4619"
        y2="127.896"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_5708_65144"
        x1="49.0927"
        y1="129.37"
        x2="48.5164"
        y2="130.492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint43_linear_5708_65144"
        x1="48.4082"
        y1="130.452"
        x2="47.8318"
        y2="131.574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint44_linear_5708_65144"
        x1="47.7234"
        y1="131.534"
        x2="47.147"
        y2="132.657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint45_linear_5708_65144"
        x1="47.0386"
        y1="132.616"
        x2="46.4622"
        y2="133.739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint46_linear_5708_65144"
        x1="48.7106"
        y1="136.305"
        x2="44.7336"
        y2="133.788"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint47_linear_5708_65144"
        x1="45.3652"
        y1="135.261"
        x2="44.7888"
        y2="136.384"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint48_linear_5708_65144"
        x1="44.6804"
        y1="136.344"
        x2="44.1041"
        y2="137.467"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint49_linear_5708_65144"
        x1="43.9963"
        y1="137.426"
        x2="43.42"
        y2="138.549"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint50_linear_5708_65144"
        x1="43.3115"
        y1="138.509"
        x2="42.7352"
        y2="139.632"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint51_linear_5708_65144"
        x1="44.9826"
        y1="142.197"
        x2="41.0056"
        y2="139.681"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint52_linear_5708_65144"
        x1="41.6372"
        y1="141.154"
        x2="41.0608"
        y2="142.277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint53_linear_5708_65144"
        x1="40.9524"
        y1="142.237"
        x2="40.376"
        y2="143.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint54_linear_5708_65144"
        x1="40.2678"
        y1="143.319"
        x2="39.6915"
        y2="144.442"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint55_linear_5708_65144"
        x1="39.5825"
        y1="144.401"
        x2="39.0062"
        y2="145.524"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint56_linear_5708_65144"
        x1="41.255"
        y1="148.09"
        x2="37.278"
        y2="145.574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint57_linear_5708_65144"
        x1="37.9089"
        y1="147.047"
        x2="37.3326"
        y2="148.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint58_linear_5708_65144"
        x1="37.2238"
        y1="148.129"
        x2="36.6475"
        y2="149.252"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint59_linear_5708_65144"
        x1="36.539"
        y1="149.212"
        x2="35.9627"
        y2="150.334"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint60_linear_5708_65144"
        x1="50.9452"
        y1="142.692"
        x2="75.2229"
        y2="172.306"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint61_linear_5708_65144"
        x1="61.1183"
        y1="144.732"
        x2="73.4427"
        y2="157.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint62_linear_5708_65144"
        x1="-220.554"
        y1="-596.398"
        x2="-218.541"
        y2="-591.668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint63_linear_5708_65144"
        x1="-214.052"
        y1="-569.854"
        x2="-212.107"
        y2="-565.284"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint64_linear_5708_65144"
        x1="79.3248"
        y1="127.496"
        x2="85.4569"
        y2="139.389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint65_linear_5708_65144"
        x1="86.9998"
        y1="126.656"
        x2="93.9679"
        y2="112.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint66_linear_5708_65144"
        x1="84.3201"
        y1="120.81"
        x2="80.7768"
        y2="131.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint67_linear_5708_65144"
        x1="58.586"
        y1="132.562"
        x2="83.1625"
        y2="162.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint68_linear_5708_65144"
        x1="92.1451"
        y1="128.902"
        x2="98.7498"
        y2="118.099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint69_linear_5708_65144"
        x1="19.9456"
        y1="124.244"
        x2="26.568"
        y2="145.796"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint70_linear_5708_65144"
        x1="11.5128"
        y1="129.669"
        x2="27.2991"
        y2="148.255"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint71_linear_5708_65144"
        x1="21.771"
        y1="123.707"
        x2="28.4102"
        y2="145.313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint72_linear_5708_65144"
        x1="3.15572"
        y1="81.7665"
        x2="42.8788"
        y2="169.656"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1473D" />
        <stop offset="1" stop-color="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint73_linear_5708_65144"
        x1="36.709"
        y1="137.49"
        x2="39.9657"
        y2="174.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="0.0578" stop-color="#FF908B" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint74_linear_5708_65144"
        x1="33.0464"
        y1="143.672"
        x2="57.5611"
        y2="212.514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint75_linear_5708_65144"
        x1="44.5325"
        y1="125.382"
        x2="38.5655"
        y2="159.699"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint76_linear_5708_65144"
        x1="115.615"
        y1="129.648"
        x2="199.332"
        y2="225.514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint77_linear_5708_65144"
        x1="123.582"
        y1="122.682"
        x2="207.3"
        y2="218.548"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint78_linear_5708_65144"
        x1="168.672"
        y1="230.011"
        x2="167.828"
        y2="201.827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint79_linear_5708_65144"
        x1="152.229"
        y1="230.504"
        x2="151.384"
        y2="202.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint80_linear_5708_65144"
        x1="154.339"
        y1="301.088"
        x2="152.974"
        y2="255.565"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint81_linear_5708_65144"
        x1="151.841"
        y1="230.515"
        x2="150.996"
        y2="202.331"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint82_linear_5708_65144"
        x1="156.544"
        y1="230.375"
        x2="155.699"
        y2="202.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint83_linear_5708_65144"
        x1="161.087"
        y1="230.24"
        x2="160.242"
        y2="202.055"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint84_linear_5708_65144"
        x1="165.867"
        y1="230.095"
        x2="165.023"
        y2="201.911"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint85_linear_5708_65144"
        x1="170.478"
        y1="229.957"
        x2="169.633"
        y2="201.773"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint86_linear_5708_65144"
        x1="104.634"
        y1="112.609"
        x2="89.7504"
        y2="221.751"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint87_linear_5708_65144"
        x1="99.0514"
        y1="141.213"
        x2="96.6227"
        y2="152.721"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#53D8FF" />
        <stop offset="1" stop-color="#3840F7" />
      </linearGradient>
      <linearGradient
        id="paint88_linear_5708_65144"
        x1="105.057"
        y1="144.323"
        x2="101.285"
        y2="154.286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint89_linear_5708_65144"
        x1="100.182"
        y1="140.07"
        x2="92.4625"
        y2="171.842"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1473D" />
        <stop offset="1" stop-color="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint90_linear_5708_65144"
        x1="98.5761"
        y1="142.706"
        x2="96.8075"
        y2="151.086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint91_linear_5708_65144"
        x1="165.293"
        y1="69.113"
        x2="157.004"
        y2="69.113"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint92_linear_5708_65144"
        x1="130.492"
        y1="20.7741"
        x2="143.197"
        y2="77.2617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint93_linear_5708_65144"
        x1="119.25"
        y1="23.3026"
        x2="131.955"
        y2="79.7902"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint94_linear_5708_65144"
        x1="117.219"
        y1="38.996"
        x2="130.27"
        y2="97.0189"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint95_linear_5708_65144"
        x1="87.9039"
        y1="12.6538"
        x2="134.671"
        y2="40.8674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1473D" />
        <stop offset="1" stop-color="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint96_linear_5708_65144"
        x1="162.697"
        y1="150.687"
        x2="156.092"
        y2="122.076"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint97_linear_5708_65144"
        x1="153.879"
        y1="111.797"
        x2="154.238"
        y2="102.495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint98_linear_5708_65144"
        x1="155.23"
        y1="104.5"
        x2="156.406"
        y2="114.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint99_linear_5708_65144"
        x1="143.096"
        y1="111.381"
        x2="143.455"
        y2="102.079"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint100_linear_5708_65144"
        x1="152.382"
        y1="153.068"
        x2="145.777"
        y2="124.458"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint101_linear_5708_65144"
        x1="145.56"
        y1="105.603"
        x2="146.735"
        y2="115.913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint102_linear_5708_65144"
        x1="162.825"
        y1="45.0665"
        x2="145.746"
        y2="119.682"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4F52FF" />
        <stop offset="1" stop-color="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint103_linear_5708_65144"
        x1="-233.365"
        y1="-735.242"
        x2="-224.739"
        y2="-717.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint104_linear_5708_65144"
        x1="152.607"
        y1="37.8053"
        x2="157.097"
        y2="57.3051"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint105_linear_5708_65144"
        x1="156.422"
        y1="42.2719"
        x2="165.729"
        y2="59.4689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1473D" />
        <stop offset="1" stop-color="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint106_linear_5708_65144"
        x1="152.749"
        y1="74.2043"
        x2="155.908"
        y2="79.8555"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint107_linear_5708_65144"
        x1="-242.995"
        y1="-730.568"
        x2="-234.369"
        y2="-712.796"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint108_linear_5708_65144"
        x1="129.697"
        y1="50.206"
        x2="121.208"
        y2="50.206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint109_linear_5708_65144"
        x1="150.183"
        y1="39.5339"
        x2="157.548"
        y2="35.0187"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint110_linear_5708_65144"
        x1="161.623"
        y1="30.5101"
        x2="152.119"
        y2="38.0552"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#09005D" />
        <stop offset="1" stop-color="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint111_linear_5708_65144"
        x1="152.122"
        y1="41.2052"
        x2="158.749"
        y2="37.1427"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEBBBA" />
        <stop offset="1" stop-color="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint112_linear_5708_65144"
        x1="153.32"
        y1="21.5699"
        x2="156.016"
        y2="38.2457"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF928E" />
        <stop offset="1" stop-color="#FE7062" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "OnboardingTradesIcon",
};
</script>
